import { client } from "../../api/client";

export const fetchPermissions = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        console.log(require("./_local/_permissionsData.json"));
        return require("./_local/_permissionsData.json");
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "usersapi/user/permissions");
            return response.data;
        } catch (error) {
            console.error("Error fetching permissions:", error);
            return [];
        }
    }
};